<template>
  <AuthLayout :heading="$nt('heading')">
    <VForm v-model="isFormValid">
      <EmailInput
        v-model="email"
        @keydown.enter.native="submit"
      />

      <VTextField
        v-model="password"
        :label="$nt('labelPassword')"
        :rules="[$rules.isRequired, $rules.isValidPassword]"
        type="password"
        @keydown.enter.native="submit"
      />
    </VForm>
    <template slot="navigation">
      <VBtn
        flat
        @click="$router.push({name: 'forgotPassword'})"
      >
        {{ $nt('forgotPassword') }}
      </VBtn>
    </template>
    <template slot="action">
      <VBtn
        :disabled="isCredentialsEmpty || !isFormValid || isLoading"
        :loading="isLoading"
        color="primary"
        type="submit"
        @click="submit"
      >
        {{ $nt('send') }}
      </VBtn>
    </template>
  </AuthLayout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EmailInput from '@/components/global-components/inputs/EmailInput.vue'
import AuthLayout from '@/components/layouts/AuthLayout'

export default {
  name: 'Login',
  components: { AuthLayout, EmailInput },
  data () {
    return {
      isLoading: false,
      isFormValid: false,
      password: process.env.VUE_APP_LOGIN_PASS || '',
      email: process.env.VUE_APP_LOGIN_USER || ''
    }
  },
  computed: {
    ...mapGetters('user', ['isAuth', 'getUser']),
    isCredentialsEmpty () {
      return !this.password.trim() || !this.email.trim()
    }
  },
  methods: {
    ...mapActions({
      login: 'user/login',
      alert: 'alert/globalAlert'
    }),
    async afterLogin () {
      if (this.isAuth) {
        this.redirect()
      }
    },
    redirect () {
      const redirectRoute = {
        agent: 'contractCreate',
        agency_manager: 'agency',
        administrator: 'agencies'
      }[this.getUser.role]
      this.$router.replace({ name: redirectRoute })
    },
    async submit () {
      if (this.isFormValid) {
        try {
          this.isLoading = true
          await this.login({ email: this.email, password: this.password })
        } catch (e) {
          this.$notification(e)
        }
        this.isLoading = false
      }
    },
    clear () {
      this.$refs.loginForm.reset()
    }
  },
  watch: {
    isAuth: {
      handler: 'afterLogin',
      immediate: true
    }
  }
}
</script>
